interface IViolationChatItems {
  id: number;
  title: string;
  value: string;
}
export const violationChatItems: IViolationChatItems[] = [
  {id: 0, title: 'رفتار غیراخلاقی و توهین‌آمیز', value: 'immoral_bahaviour'},
  {id: 1, title: 'کلاهبرداری', value: 'fraud'},
  {id: 2, title: 'اطلاعات نادرست است', value: 'wrong_info'},
  {id: 3, title: 'تبلیغ می‌کند', value: 'advertising'},
  {id: 4, title: 'موارد دیگر', value: 'other'},
];
